module.exports = __webpack_public_path__ + "static/img/2_4_1.a0396fb9.jpg";